/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Bluefin/view.blocks to change it.
import React from 'react'
import bluefinPng from "./bluefin.png"
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Bluefin({
  children,
  viewPath = "/App/Account/Content/Settings/Content/PaymentProviders/Accounts/Content/ProviderAccount/Provider/Bluefin"
  
}) {
  return (<React.Fragment
>
<img
  data-testid="Bluefin.Image"
  data-view-path={viewPath}
 alt={""}
 src={bluefinPng}
 className={`views-block ${styles.Image}`}
/>
{children}
</React.Fragment>)
}